import { createRouter, createWebHashHistory } from "vue-router";
import { notif } from "@/utils";
import { useRootStore } from "@/stores/root";
import { useCustomerStore } from "@/stores/customers";
import { useLocationStore } from "@/stores/location";
import { useSettingsStore } from "@/stores/settings";

const router = createRouter({
  history: createWebHashHistory(/*import.meta.env.BASE_URL*/),
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        main: () => import("../views/Home/HomeMain.vue"),
        header: () => import("../views/Home/HomeHeader.vue"),
        footer: () => import("../views/Home/HomeFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Home",
      },
    },
    {
      path: "/login",
      name: "Login",
      components: {
        header: () => import("../views/Login/LoginHeader.vue"),
        main: () => import("../views/Login/LoginMain.vue"),
        footer: () => import("../views/Login/LoginFooter.vue"),
      },
      meta: {
        requiresAuth: false,
        requiresCustomer: false,
        title: "Login",
      },
    },

    {
      path: "/customers/search",
      name: "ClientiRicerca",
      components: {
        header: () => import("../views/ClientiRicerca/ClientiRicercaHeader.vue"),
        main: () => import("../views/ClientiRicerca/ClientiRicercaMain.vue"),
        footer: () => import("../views/ClientiRicerca/ClientiRicercaFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Ricerca cliente",
      },
    },
    {
      path: "/ordine/:idDoc/:noReload?",
      name: "Ordine",
      components: {
        header: () => import("../views/Ordine/OrdineHeader.vue"),
        main: () => import("../views/Ordine/OrdineMain.vue"),
        footer: () => import("../views/Ordine/OrdineFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Ordine",
      },
    },
    {
      path: "/ordine/:idDoc/👀/:q",
      name: "OrdineRicerca",
      components: {
        header: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaHeader.vue"),
        main: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaMain.vue"),
        footer: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Ricerca articolo",
      },
    },
    {
      path: "/ordine/:idDoc/%F0%9F%91%80/:q",
      name: "OrdineRicerca",
      components: {
        header: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaHeader.vue"),
        main: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaMain.vue"),
        footer: () => import("../views/Ordine/OrdineRicerca/OrdineRicercaFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Ricerca articolo",
      },
    },
    {
      path: "/ordine/:idDoc/riepilogo",
      name: "RiepilogoOrdine",
      components: {
        header: () => import("../views/Ordine/RiepilogoOrdine/RiepilogoOrdineHeader.vue"),
        main: () => import("../views/Ordine/RiepilogoOrdine/RiepilogoOrdineMain.vue"),
        footer: () => import("../views/Ordine/RiepilogoOrdine/RiepilogoOrdineFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Riepilogo ordine",
      },
    },
    {
      path: "/storico",
      name: "StoricoOrdini",
      components: {
        header: () => import("../views/StoricoOrdini/StoricoOrdiniHeader.vue"),
        main: () => import("../views/StoricoOrdini/StoricoOrdiniMain.vue"),
        footer: () => import("../views/StoricoOrdini/StoricoOrdiniFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Storico ordini",
      },
    },
    {
      path: "/storico/:sTipoDoc/:iVecnnmpro",
      name: "StoricoOrdiniDettaglio",
      props: true,
      components: {
        header: () => import("../views/StoricoOrdini/StoricoOrdiniDettaglio/StoricoOrdiniDettaglioHeader.vue"),
        main: () => import("../views/StoricoOrdini/StoricoOrdiniDettaglio/StoricoOrdiniDettaglioMain.vue"),
        footer: () => import("../views/StoricoOrdini/StoricoOrdiniDettaglio/StoricoOrdiniDettaglioFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Dettaglio ordine",
      },
    },
    {
      path: "/fatture",
      name: "StoricoFatture",
      components: {
        header: () => import("../views/StoricoFatture/StoricoFattureHeader.vue"),
        main: () => import("../views/StoricoFatture/StoricoFattureMain.vue"),
        footer: () => import("../views/StoricoFatture/StoricoFattureFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Storico fatture",
      },
    },
    {
      path: "/pagamenti",
      name: "Pagamenti",
      components: {
        header: () => import("../views/Pagamenti/PagamentiHeader.vue"),
        main: () => import("../views/Pagamenti/PagamentiMain.vue"),
        footer: () => import("../views/Pagamenti/PagamentiFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Pagamenti",
      },
    },
    {
      path: "/incassi",
      name: "Incassi",
      components: {
        header: () => import("../views/Incassi/IncassiHeader.vue"),
        main: () => import("../views/Incassi/IncassiMain.vue"),
        footer: () => import("../views/Incassi/IncassiFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Incassi",
      },
    },
    {
      path: '/sales',
      name: 'Sales',
      components: {
        header: () => import('../views/Sales/SalesHomeHeader.vue'),
        main: () => import('../views/Sales/SalesHomeMain.vue'),
        footer: () => import('../views/Sales/SalesHomeFooter.vue'),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Statistiche",
        show: () =>{
          const settingsStore = useSettingsStore();
          return settingsStore.STATS;
        }
      },
    },
    {
      path: "/sales/:interval/::customer?/:customerDest?",
      name: "SalesDetails",
      components: {
        header: () => import("../views/Sales/SalesDetailsHeader.vue"),
        main: () => import("../views/Sales/SalesDetailsMain.vue"),
        footer: () => import("../views/Sales/SalesDetailsFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: false,
        title: "Statistiche vendite",
      },
      props: true,
    },
    {
      path: "/changelog",
      name: "Changelog",
      components: {
        main: () => import("../views/Changelog/ChangelogMain.vue"),
      },
      meta: {
        requiresAuth: false,
        requiresCustomer: false,
        title: "Changelog",
      },
    },
    {
      path: "/dati_vendita",
      name: "DatiVendita",
      components: {
        header: () => import("../views/DatiVendita/DatiVenditaHeader.vue"),
        main: () => import("../views/DatiVendita/DatiVenditaMain.vue"),
        footer: () => import("../views/DatiVendita/DatiVenditaFooter.vue"),
      },
      meta: {
        requiresAuth: true,
        requiresCustomer: true,
        title: "Dati vendita",
      },
    },
    {
      path: "/reset",
      name: "Reset",
      components: {
        main: () => import("../views/ResetStore.vue"),
      },
      meta: {
        requiresAuth: false,
        requiresCustomer: false,
        title: "Reset",
      },
    },
    /*
    {
      path: "/devtest",
      name: "DevTest",
      components: {
        main: () => import("../views/DevTest/DevTestMain.vue"),
      },
      meta: {
        requiresAuth: false,
        requiresCustomer: false,
        title: "Dev Test Fuse.js",
      },
    },*/
  ],
});

router.beforeEach(async (to, from, next) => {
  const store = useRootStore();
  const customeStore = useCustomerStore();
  console.log("[router] beforeEach", to);
  // le pagine che richiedono il login -> redirect alla pagina di login se non autenticato
  if (to.meta.requiresAuth && !store.isAuthenticated) {
    notif("Attenzione", "Necessaria autenticazione", "warn"); // non funziona -.-'
    next({ name: "Login" });
    return;
  }
  // non visualizzare pagine che richiedono la selezione del cliente se il cliente non è stato selezionato
  if (to.meta.requiresCustomer && !customeStore.CUSTOMERS_selected) {
    next({ name: "ClientiRicerca" });
    return;
  }
  const locationStore = useLocationStore();
  if (!locationStore.ROUTER_BEFORE_EACH_get.length) {
    next();
  } else {
    for (const callback of locationStore.ROUTER_BEFORE_EACH_get) {
      await callback(to, from, next);
    }
  }
});

export default router;
